import React from "react"
import "../../assets/scss/components/app-loader.scss"
import logo from "../../assets/img/logo/logo-inlog.png"


class SpinnerComponent extends React.Component {
  render() {
    return (
      <div className="fallback-spinner vh-100">
        <img className="fallback-logo" src={logo} width="180" alt="logo" />
        <div className="loading mt-2">
          <div className="effect-1 effects"></div>
          <div className="effect-2 effects"></div>
          <div className="effect-3 effects"></div>
        </div>
      </div>
    )
  }
}

export default SpinnerComponent
